import { Routes } from '@angular/router';
import { authGuard } from './core/auth/guards/auth.guard';
import { adminGuard } from './core/auth/guards/admin.guard';
import { moduleEnabledGuard } from './core/auth/guards/module-enabled.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'bookings' },
  {
    path: 'bookings',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/bookings/pages/bookings-list/bookings-list.component').then(m => m.BookingsListComponent),
    children: [
      { path: '', redirectTo: 'tables', pathMatch: 'full' },
      {
        path: 'tables',
        canActivate: [moduleEnabledGuard],
        data: { moduleKey: 'tables' },
        loadComponent: () =>
          import('./features/bookings/tabs/tables-bookings-tab/tables-bookings-tab.component').then(m => m.TablesBookingsTabComponent),
      },
      {
        path: 'vehicles',
        canActivate: [moduleEnabledGuard],
        data: { moduleKey: 'vehicles' },
        loadComponent: () =>
          import('./features/bookings/tabs/vehicles-bookings-tab/vehicles-bookings-tab.component').then(m => m.VehiclesBookingsTabComponent),
      },
      {
        path: 'rooms',
        canActivate: [moduleEnabledGuard],
        data: { moduleKey: 'rooms' },
        loadComponent: () =>
          import('./features/bookings/tabs/rooms-bookings-tab/rooms-bookings-tab.component').then(m => m.RoomsBookingsTabComponent),
      },
    ],
  },
  {
    path: 'admin',
    canActivate: [authGuard, adminGuard],
    children: [
      {
        path: 'tables',
        canActivate: [moduleEnabledGuard],
        data: { moduleKey: 'tables' },
        loadComponent: () =>
          import('./features/tables/pages/tables-editor/tables-editor.component').then(m => m.TablesEditorComponent),
      },
      {
        path: 'vehicles',
        canActivate: [moduleEnabledGuard],
        data: { moduleKey: 'vehicles' },
        loadComponent: () =>
          import('./features/vehicles/pages/vehicles-list/vehicles-list.component').then(m => m.VehiclesListComponent),
      },
      {
        path: 'rooms',
        canActivate: [moduleEnabledGuard],
        data: { moduleKey: 'rooms' },
        loadComponent: () =>
          import('./features/rooms/pages/rooms-list/rooms-list.component').then(m => m.RoomsListComponent),
      },
    ],
  },
  {
    path: 'settings',
    canActivate: [authGuard],
    loadComponent: () => import('./features/settings/pages/settings.component'),
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./pages/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent),
  },
  { path: '**', redirectTo: 'bookings' },
];
